import { ReactElement } from "react";

import { CampaignContactAudienceImportArgs } from "~frontend/__generated__/graphql";

import { CampaignForEditor } from "../../types";
import LegacySubscriberImport from "./LegacySubscriberImport";
import SubscriberTargeting from "./SubscriberTargeting";

export default function SubscriberImport({
  campaign,
  previousJobArgs,
  readOnly,
}: {
  campaign: CampaignForEditor;
  previousJobArgs: CampaignContactAudienceImportArgs;
  readOnly?: boolean;
}): ReactElement {
  const previousJobFilters = previousJobArgs?.filter
    ? JSON.parse(previousJobArgs?.filter)
    : null;

  const useLegacyImportUI =
    !!previousJobFilters && !!previousJobFilters.combineWith;

  return useLegacyImportUI ? (
    <LegacySubscriberImport campaign={campaign} readOnly={readOnly} />
  ) : (
    <SubscriberTargeting
      campaign={campaign}
      previousJobFilters={previousJobFilters}
      readOnly={readOnly}
    />
  );
}
